import React from "react";
import { IndicatorsPage } from "componentes/templates/indicatorsPage";



function Home() {

  return (
    <>

      <IndicatorsPage>
        <center>
        <img src="https://ora.otca.org/wp-content/uploads/2021/09/imageninicio.png" alt={"Logo"} />
        </center>
      </IndicatorsPage>

    </>
  );

}
export default Home;